import React, { Component } from 'react';
import { getTopicLabel, getTypeLabel } from './tools';
import { AllFiltersButton } from './components/filterbar/AllFiltersButton';
import { CurrentFilters } from './components/filterbar/CurrentFilters';
import { CompulsoryFilter } from './components/compulsoryfilter';
import { Select } from './components/filterbar/Select';

class FilterBar extends Component {
	constructor(props) {
		super(props);
		this.addTopicToFilter = this.addTopicToFilter.bind(this);
		this.addTypeToFilter = this.addTypeToFilter.bind(this);
		this.addLanguageToFilter = this.addLanguageToFilter.bind(this);
		this.clearAllFilters = this.clearAllFilters.bind(this);
		this.clearFilter = this.clearFilter.bind(this);
		this.toggleCompulsory = this.toggleCompulsory.bind(this);
	}

	// Bad but works
	handleAddEvent(event, currentFilters, setFunction, allItems) {
		const element = event.target;
		if ( element.value === 'all' ) {
			// Add/remove all
			if ( element.checked === false ) {
				setFunction([]);
			} else {
				setFunction(allItems);
			}
			return;
		}

		let clone = [...currentFilters];

		// Checkbox so remove item
		if ( element.checked === false ) {
			const index = clone.indexOf(element.value);
			if ( index >= 0 ) {
				clone.splice(index, 1);
				setFunction(clone);
			}
		} else {
			if ( ! clone.includes(element.value) ) {
				clone.push(element.value)
				setFunction(clone);
			}
		}
	}

	addTopicToFilter(event) {
		this.handleAddEvent(event, this.props.filterTopics, this.props.setFilterTopics, this.props.topicCategories);
	}

	addTypeToFilter(event) {
		this.handleAddEvent(event, this.props.filterDocumentTypes, this.props.setFilterDocumentTypes, this.props.documentTypes);
	}

	addLanguageToFilter(event) {
		this.handleAddEvent(event, this.props.filterLanguages, this.props.setFilterLanguages, this.props.languages);
	}

	toggleCompulsory(event) {
		this.props.setFilterCompulsory(event.target.checked === true);
	}

	clearAllFilters(event) {
		event.preventDefault();
		this.props.setFilterTopics([]);
		this.props.setFilterDocumentTypes([]);
		this.props.setFilterLanguages([]);
		this.props.setFilterCompulsory(false);
	}

	clearFilter(event, category, item) {
		event.preventDefault();
		if ( category === 'topic' ) {
			let currentFilters = [...this.props.filterTopics];
			const index = currentFilters.indexOf(item);
			if ( index >= 0 ) {
				currentFilters.splice(index, 1);
				this.props.setFilterTopics(currentFilters);
			}
		} else if ( category === 'type' ) {
			let currentFilters = [...this.props.filterDocumentTypes];
			const index = currentFilters.indexOf(item);
			if ( index >= 0 ) {
				currentFilters.splice(index, 1);
				this.props.setFilterDocumentTypes(currentFilters);
			}
		} else if ( category === 'language' ) {
			let currentFilters = [...this.props.filterLanguages];
			const index = currentFilters.indexOf(item);
			if ( index >= 0 ) {
				currentFilters.splice(index, 1);
				this.props.setFilterLanguages(currentFilters);
			}
		}
	}

	// Creates array of options with counts for options
	makeOptionArray(categories, posts, acfKey) {
		let typeOptions = [];
		let allCount = 0;
		categories.forEach(document => {
			let count = 0;
			posts.forEach(topic => {
				topic[1].forEach(post => {
					if ( post.acf[acfKey] === document) {
						count++;
					}
				});
			});
			typeOptions.push({
				value: document,
				count: count,
			});
			allCount += count;
		});
		return [typeOptions, allCount];
	}

	// I was hoping this could be the same as above...
	makeLanguageOptionArray(categories, posts) {
		let typeOptions = [];
		// Keep track of how many posts have languages
		let langPosts = [];
		categories.forEach(language => {
			let count = 0;
			posts.forEach(topic => {
				topic[1].forEach(post => {
					if ( Array.isArray(post.acf.download_files)) {
						post.acf.download_files.forEach(download => {
							if ( language === download.language ) {
								count++;
							}
						});
						if ( ! langPosts.includes( post.id ) ) {
							langPosts.push(post.id);
						}
					}
				});
			});
			typeOptions.push({
				value: language,
				count: count,
			});
		});
		return [typeOptions, langPosts.length];
	}


	render() {
		// Generate options - we need counts for the current filters
		const topicCategoriesPosts = this.props.getFilteredPosts([], this.props.filterDocumentTypes, this.props.filterLanguages, this.props.filterCompulsory);
		let topicOptions = [];
		let allTopicCount = 0;
		// Ideally we'd loop through the post list just once.
		this.props.topicCategories.forEach(element => {
			let count = 0;
			topicCategoriesPosts.forEach(topic => {
				if ( element === topic[0]) {
					count = topic[1].length;
				}
			});
			topicOptions.push({
				value: element,
				count: count,
			});
			allTopicCount += count;
		});

		const typesCategoriesPosts = this.props.getFilteredPosts(this.props.filterTopics, [], this.props.filterLanguages, this.props.filterCompulsory);
		const [typeOptions, allTypeCount] = this.makeOptionArray(this.props.documentTypes, typesCategoriesPosts, 'document_type');
		const languageCategoriesPosts = this.props.getFilteredPosts(this.props.filterTopics, this.props.filterDocumentTypes, [], this.props.filterCompulsory);
		const [languageOptions, allLanguageCount] = this.makeLanguageOptionArray(this.props.languages, languageCategoriesPosts);

		return (
			<>
				<div id="toolkit-filter-bar">

					<span className="d-none d-md-inline-block h6 m-0">Filter by:</span>

					<span className="input-wrap d-none d-md-inline-block">
						<Select
							options={topicOptions}
							allCount={allTopicCount}
							selectedOptions={this.props.filterTopics}
							labelFunction={getTopicLabel}
							blankLabel='Topic'
							id='topic'
							onChangeCallback={this.addTopicToFilter}
						/>
					</span>

					<span className="input-wrap d-none d-lg-inline-block">
						<Select
							options={typeOptions}
							allCount={allTypeCount}
							selectedOptions={this.props.filterDocumentTypes}
							labelFunction={getTypeLabel}
							blankLabel='Document type'
							id='document'
							onChangeCallback={this.addTypeToFilter}
						/>
					</span>

					<CompulsoryFilter
						checked={this.props.filterCompulsory}
						id={'is_compulsory'}
						onChange={this.toggleCompulsory}
						className='input-wrap d-none d-xl-inline-flex align-items-center'
					/>

					<AllFiltersButton
						topicCategories={this.props.topicCategories}
						documentTypes={this.props.documentTypes}
						languages={this.props.languages}
						filterTopics={this.props.filterTopics}
						filterDocumentTypes={this.props.filterDocumentTypes}
						filterLanguages={this.props.filterLanguages}
						topicOptions={topicOptions}
						typeOptions={typeOptions}
						languageOptions={languageOptions}
						allTopicCount={allTopicCount}
						allTypeCount={allTypeCount}
						allLanguageCount={allLanguageCount}
						filterCompulsory={this.props.filterCompulsory}
						filteredPostCount={this.props.filteredPostCount}
						filteredPostList={this.props.filteredPostList}
						allPostCount={this.props.allPostCount}
						toggleCompulsory={this.toggleCompulsory}
						topicCallback={this.addTopicToFilter}
						typeCallback={this.addTypeToFilter}
						languagesCallback={this.addLanguageToFilter}
						clearFilter={this.clearFilter}
						clearAllFilters={this.clearAllFilters}
					/>
				</div>

				<CurrentFilters
					filterTopics={this.props.filterTopics}
					filterDocumentTypes={this.props.filterDocumentTypes}
					filterLanguages={this.props.filterLanguages}
					clearFilter={this.clearFilter}
					clearAllFilters={this.clearAllFilters}
				/>
			</>
		);
	}
}
export default FilterBar;
